import { CrashSeverity, SignalizedRampTerminal } from "../SPFConstants";
import { getpEx, getpOut } from "./rampCMFHelper";

const getPxrd = ({ aadtin, aadtout, aadten, aadtex }: any): number => {
  return (aadtin + aadtout) / (aadtin + aadtout + aadten + aadtex);
};

export const getCMF13 = ({
  aadten,
  aadtex,
  aadtin,
  aadtout,
  crashSeverity,
  numOutsideCrossroadLegDriveways: ndw,
}: SignalizedRampTerminal) => {
  const a = crashSeverity === CrashSeverity.FATAL_INJURY ? 0.158 : 0.203;
  const pOut = getpOut({ aadtin, aadtout, aadtex, aadten });
  return (1 - pOut) * 1 + pOut * Math.exp(a * ndw);
};

export const getCMF16 = ({
  aadten,
  aadtex,
  aadtin,
  aadtout,
  bothApproachesNumThruLanes,
  crashSeverity,
  insideApproachNumThruLanes,
  isInsideApproachProtectedOnlyMode,
}: SignalizedRampTerminal) => {
  if (isInsideApproachProtectedOnlyMode) {
    const a = crashSeverity === CrashSeverity.FATAL_INJURY ? -0.363 : -0.223;
    const pXrd = getPxrd({ aadtin, aadtout, aadten, aadtex });
    const noOut = bothApproachesNumThruLanes - insideApproachNumThruLanes;

    return (1 - pXrd) * 1 + pXrd * Math.exp(a * noOut); // TOOO - 10/4/23 - sonu to ask pete about noOut definition
  }

  return 1;
};

export const getCMF17 = ({
  aadtin,
  aadtout,
  aadten,
  aadtex,
  crashSeverity,
  isOutsideApproachChannelized,
}: SignalizedRampTerminal) => {
  if (isOutsideApproachChannelized) {
    const a = crashSeverity === CrashSeverity.FATAL_INJURY ? 0.466 : 0.465;
    const pOut = getpOut({ aadtin, aadtout, aadten, aadtex });
    return (1 - pOut) * 1 + pOut * Math.exp(a);
  }
  return 1;
};

export const getCMF18 = ({
  aadtin,
  aadtout,
  aadten,
  aadtex,
  crashSeverity,
  isExitRampApproachChannelized,
}: SignalizedRampTerminal) => {
  if (isExitRampApproachChannelized) {
    const a = crashSeverity === CrashSeverity.FATAL_INJURY ? 0.992 : 1.429;
    const pEx = getpEx({ aadtin, aadtout, aadten, aadtex });
    return (1 - pEx) * 1 + pEx * Math.exp(a);
  }
  return 1;
};

export const getCMF19 = ({
  crashSeverity,
  isNonRampPublicStreetPresent,
}: SignalizedRampTerminal) => {
  const a = crashSeverity === CrashSeverity.FATAL_INJURY ? 0.592 : 0.52;
  return isNonRampPublicStreetPresent ? Math.exp(a) : 1;
};
